<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isFooter="true"
      :isTotalAmount="false"
      @editRemarks="editRemarks"
    >
      <template #footer>
        <v-spacer></v-spacer>

        <NormalButton
          :text="$t('common.input_fix')"
          color="white"
          class="pr-5"
          textColor="thinText--text"
          height="50px"
          width="130px"
          @click="inputedValue.dialog = false"
        />
        <NormalButton
          :text="$t('common.input_save')"
          height="50px"
          width="130px"
          @click="register()"
        />
        <DialogAlertSuccess
          v-model="completeDialog"
          :text="$t('common.common_register-complete')"
        />
      </template>
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import InfoDialogBase from './StorageInfoDialogBase'
import { supplierUtil } from '@/util'

import NormalButton from '@/components/items/Buttons/NormalButton'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

export default {
  components: {
    InfoDialogBase,

    NormalButton,
    DialogAlertSuccess
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    registerData: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    recItems: {},
    pageData: [],
    completeDialog: false,
    remarks: ''
  }),
  created() {
    // this.init()
  },
  methods: {
    ...mapActions('StockMove', ['registerStockMove']),
    ...mapActions('Common', ['setIsLoading']),

    init() {
      if (this.inputedValue.dialog) {
        const productMovesTmp = this.registerData.product.data.map(
          (ele, index) => {
            return {
              productMoveId: index,
              price: ele.price,
              quantity: ele.count,
              currencyId: ele.currencyId,
              exportSubjectFlg: ele.exportSubjectFlg,
              product: ele
            }
          }
        )

        this.recItems = {
          productMoves: productMovesTmp,
          client: this.registerData.client,
          totalList: this.registerData.totalList
        }
      }

      this.pageData = [
        {
          title: 'storage.storage_storage-move-info',
          name: 'paymentInfo',
          items: [],
          itemKey: ''
        },
        {
          title: `${this.$t('storage.storage_storage-move-detail')}（${
            this.registerData.storage.ship.label
          } → ${this.registerData.storage.loading.label}）`,
          name: 'paymentHistory',
          headers: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '8%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '30%',
              class: 'rgba(151, 198, 234, 0.1)'
            },
            {
              text: 'product.product_supplier',
              value: 'product.supplierId',
              sortable: false,
              width: '12%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'storage.storage_storage-move-quantity',
              value: 'quantity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            }
          ],
          items: [],
          footers: [],
          itemKey: Object.keys(this.recItems).length ? this.recItems.saleId : ''
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        }
      ]
    },
    async register() {
      this.setIsLoading(true)
      const isSuccess = await this.registerStockMove({
        registerData: this.registerData,
        remarks: this.remarks
      })
      if (isSuccess) {
        this.completeDialog = true
      }
      this.setIsLoading(false)
    },
    editRemarks(...args) {
      const [remarks] = args
      this.remarks = remarks
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    },
    completeDialog: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push({ name: 'storage.history' })
        this.inputedValue.dialog = false
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
